import { createContext } from 'react';
import { DELIVERY_PASS_NOT_AVAILABLE } from 'constants/delivery-pass-statuses';

export const DeliveryPassContext = createContext<string>(DELIVERY_PASS_NOT_AVAILABLE);
